import React, {useEffect} from 'react';
import { Loading } from '@gull';
import { BlobProvider } from '@react-pdf/renderer';
import { exposeServerRenderError, exposePdfToServerRender } from './serverRender';

// Transmet le PDF généré au rendu serveur (Pennylane) une fois le blob prêt
const ServerRenderExposer = ({blob}) => {
    useEffect(() => { exposePdfToServerRender(blob) }, [blob])
    return false
}

// Signale au rendu serveur une erreur de génération du PDF
const ServerRenderExposerError = ({error}) => {
    useEffect(() => { exposeServerRenderError(error) }, [error])
    return false
}

/**
 * Génère et affiche l'aperçu PDF (BlobProvider + iframe) d'un document public.
 * Factorise le rendu commun aux pages publiques ticket / ticket facture / commande / devis.
 *
 * @param {JSX.Element} document - Élément PDF (@react-pdf/renderer) à générer
 * @param {string} title - Titre d'accessibilité de l'iframe
 */
const PublicPdfPreview = ({document,title}) => {
    return(
        <div className='m-3'>
            <BlobProvider document={document}>
                {({ url, blob, loading:pdfLoading, error:pdfError }) => (
                    pdfLoading ?
                        <Loading></Loading>
                    : pdfError ?
                        <ServerRenderExposerError error={pdfError} />
                    :
                        <>
                        <ServerRenderExposer blob={blob} />
                        <iframe
                            src={url}
                            width="100%"
                            height="1000px"
                            title={title}
                            style={{ border: 'none', marginTop: '20px' }}
                        ></iframe>
                        </>
                )}
            </BlobProvider>
        </div>
    )
}

export default PublicPdfPreview;
